import { useContext } from "react"
import { AppConstantContext } from "./appConstantContext"

export const useAppConstants = () => {
    const appConstants = useContext(AppConstantContext);
    return appConstants
}